<template lang="html">
  <StandardDialog
    title='Contact Trip Planner'>
    <template #activator='{ on }'>
      <slot name="activator" :on='on'>
        <v-btn class='default' v-on='on' dark>Activator</v-btn>
      </slot>
    </template>
    <template #main>
      <slot name='main'>
        <v-select
          label='Email Type'
          :items='formattedEmails'
          @input='$emit("input", $event)'/>
      </slot>
    </template>
    <template #actions=" { deactivate }">
      <slot name="actions" :deactivate='deactivate'>
        <v-btn color="secondary" v-on='deactivate'> Close </v-btn>
      </slot>
    </template>
  </StandardDialog>
</template>

<script>
import StandardDialog from './StandardDialog'
import { mapGetters } from 'vuex'
export default {
  components: {
    StandardDialog
  },
  props: ['value'],
  data: () => { return { } },
  computed: {
    formattedEmails () {
      return [{value: this.byType('a').id, text: 'Quote Confirmation'}]
    },
    ...mapGetters('email-templates', ['byType'])
  }
}
</script>

<style lang="css" scoped>
</style>
